/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   Bounding boxes of US states and Canadian provinces
 */

export const stateBoundingBoxes = {
  //  [minlng,     minlat,    maxlng,    maxlat],
  // US data from https://anthonylouisdagostino.com/bounding-boxes-for-all-us-states/
  AL: [-88.473227, 30.223334, -84.88908, 35.008028],
  AK: [-179.148909, 51.214183, 179.77847, 71.365162],
  AS: [-171.089874, -14.548699, -168.1433, -11.046934],
  AZ: [-114.81651, 31.332177, -109.045223, 37.00426],
  AR: [-94.617919, 33.004106, -89.644395, 36.4996],
  CA: [-124.409591, 32.534156, -114.131211, 42.009518],
  CO: [-109.060253, 36.992426, -102.041524, 41.003444],
  MP: [144.886331, 14.110472, 146.064818, 20.553802],
  CT: [-73.727775, 40.980144, -71.786994, 42.050587],
  DE: [-75.788658, 38.451013, -75.048939, 39.839007],
  DC: [-77.119759, 38.791645, -76.909395, 38.99511],
  FL: [-87.634938, 24.523096, -80.031362, 31.000888],
  GA: [-85.605165, 30.357851, -80.839729, 35.000659],
  GU: [144.618068, 13.234189, 144.956712, 13.654383],
  HI: [-178.334698, 18.910361, -154.806773, 28.402123],
  ID: [-117.243027, 41.988057, -111.043564, 49.001146],
  IL: [-91.513079, 36.970298, -87.494756, 42.508481],
  IN: [-88.09776, 37.771742, -84.784579, 41.760592],
  IA: [-96.639704, 40.375501, -90.140061, 43.501196],
  KS: [-102.051744, 36.993016, -94.588413, 40.003162],
  KY: [-89.571509, 36.497129, -81.964971, 39.147458],
  LA: [-94.043147, 28.928609, -88.817017, 33.019457],
  ME: [-71.083924, 42.977764, -66.949895, 47.459686],
  MD: [-79.487651, 37.911717, -75.048939, 39.723043],
  MA: [-73.508142, 41.237964, -69.928393, 42.886589],
  MI: [-90.418136, 41.696118, -82.413474, 48.2388],
  MN: [-97.239209, 43.499356, -89.491739, 49.384358],
  MS: [-91.655009, 30.173943, -88.097888, 34.996052],
  MO: [-95.774704, 35.995683, -89.098843, 40.61364],
  MT: [-116.050003, 44.358221, -104.039138, 49.00139],
  NE: [-104.053514, 39.999998, -95.30829, 43.001708],
  NV: [-120.005746, 35.001857, -114.039648, 42.002207],
  NH: [-72.557247, 42.69699, -70.610621, 45.305476],
  NJ: [-75.559614, 38.928519, -73.893979, 41.357423],
  NM: [-109.050173, 31.332301, -103.001964, 37.000232],
  NY: [-79.762152, 40.496103, -71.856214, 45.01585],
  NC: [-84.321869, 33.842316, -75.460621, 36.588117],
  ND: [-104.0489, 45.935054, -96.554507, 49.000574],
  OH: [-84.820159, 38.403202, -80.518693, 41.977523],
  OK: [-103.002565, 33.615833, -94.430662, 37.002206],
  OR: [-124.566244, 41.991794, -116.463504, 46.292035],
  PA: [-80.519891, 39.7198, -74.689516, 42.26986],
  PR: [-67.945404, 17.88328, -65.220703, 18.515683],
  RI: [-71.862772, 41.146339, -71.12057, 42.018798],
  SC: [-83.35391, 32.0346, -78.54203, 35.215402],
  SD: [-104.057698, 42.479635, -96.436589, 45.94545],
  TN: [-90.310298, 34.982972, -81.6469, 36.678118],
  TX: [-106.645646, 25.837377, -93.508292, 36.500704],
  VI: [-65.085452, 17.673976, -64.564907, 18.412655],
  UT: [-114.052962, 36.997968, -109.041058, 42.001567],
  VT: [-73.43774, 42.726853, -71.464555, 45.016659],
  VA: [-83.675395, 36.540738, -75.242266, 39.466012],
  WA: [-124.763068, 45.543541, -116.915989, 49.002494],
  WV: [-82.644739, 37.201483, -77.719519, 40.638801],
  WI: [-92.888114, 42.491983, -86.805415, 47.080621],
  WY: [-111.056888, 40.994746, -104.05216, 45.005904],
  // Canadian data from https://gis.stackexchange.com/questions/154740/lat-and-long-extents-of-canadian-provinces
  SK: [-109.99, 48.99, -101.36, 60.0],
  AB: [-120.0, 48.99, -109.99, 60.0],
  BC: [-139.06, 48.3, -114.03, 60.0],
  NU: [-120.68, 51.64, -61.08, 83.11],
  NT: [-136.44, 60.0, -101.98, 78.76],
  YT: [-141.0, 60.0, -123.81, 69.65],
  ON: [-95.16, 41.66, -74.34, 56.86],
  QC: [-79.76, 44.99, -57.1, 62.59],
  NB: [-69.06, 44.6, -63.77, 48.07],
  NS: [-66.32, 43.42, -59.68, 47.03],
  NL: [-67.8, 46.61, -52.61, 60.37],
  MB: [-102.03, 48.99, -88.94, 60.0],
  PE: [-64.41, 45.95, -61.97, 47.06],
} as const
